import React from 'react';
import CustomTreeView from '../../../../../components/Tree/CustomTreeView';
import ScheduleSelectorDayTime from './../../../../../components/ScheduleSelectorDayTime';
import WorkShiftAccessCardApp from '../Functionality/WorkShiftAccessCardApp';
import TitledCard from '../Subcomponents/TitledCard';
import { IconScheduleTable, IconZoneTitle } from '../../../../../components/buttons/IconButtons';

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 * @param id
 * @param setModified
 * @param schedules
 * @param setSchedules
 * @param triggerClear
 * @param setTriggerClear
 * @returns {JSX.Element}
 * @constructor
 */

const WorkShiftAccessCard = ({id, setModified, schedules, setSchedules, triggerClear, setTriggerClear}) => {
    const {
        fromValue,
        setfromValue,
        toValue,
        setToValue,
        setAllDays,
        allTime,
        setAllTime,
        checked,
        setChecked,
        dayArray,
        setDayArray,
        handleCheck,
        handleCLick,
        emptyFields,
        disabled
    } = WorkShiftAccessCardApp({
        id,
        setModified,
        schedules,
        setSchedules,
        triggerClear,
        setTriggerClear
    });

    return (
        <div className='row'>
            <div className='col-12 col-lg-6 d-flex pr-1 p-0'>
                <TitledCard
                    title={'zones'}
                    icon={<IconZoneTitle className={"mr-8px mb-1 icon-color-general-950"} />}
                >
                    <div className='work_shift_tree_view'>
                        <CustomTreeView
                            tittle={''}
                            checked={checked}
                            onInputchange={handleCheck}
                            isChecked={checked}
                            setChecked={setChecked}
                            className={"h-100"}
                        />
                    </div>
                </TitledCard>
            </div>
            <div className='col-12 col-lg-6 d-flex pl-1 p-0'>
                <TitledCard
                    title={'active_schedule'}
                    icon={<IconScheduleTable className={"mr-8px mb-1 icon-color-general-950"} />}
                >
                    <ScheduleSelectorDayTime
                        dayArray={dayArray}
                        allTime={allTime}
                        fromValue={fromValue}
                        setfromValue={setfromValue}
                        toValue={toValue}
                        setToValue={setToValue}
                        handleCLick={handleCLick}
                        setDayArray={setDayArray}
                        setAllDays={setAllDays}
                        setAllTime={setAllTime}
                        emptyFields={emptyFields}
                        disabled={disabled}
                    />
                </TitledCard>
            </div>
        </div>
    );
};

export default WorkShiftAccessCard;
